import axios from "axios";
import {
  addToJobLogs,
  resetLoading,
  setError,
  setJob,
  setJobLogs,
  setJobLogSearchResults,
  setJobs,
  setLoading,
  setMessages,
  setPagination,
  setSearchResults,
  setTotals,
  updateJobLog,
  removeJobLog,
  updateJobProgressStatus,
  updateJobStatus,
  cacheJobLogPhotos,
  clearJobPhotosCache,
} from "../slices/job";

export const getJobs = (type) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get(`/api/jobs/list/${type}`);
    const { jobs, pagination } = data;

    //console.log({ bookingsFilter });
    //console.log({ jobs });
    //const filteredJobs = jobs.filter((job) => job.BOOKING === (bookingsFilter ? 1 : 0) && job.CANCELLED === 0);

    //dispatch(setJobs(filteredJobs));
    dispatch(setJobs(jobs));
    //dispatch(setJobs(jobs));
    dispatch(setPagination(pagination));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading jobs. Please try again later"
      )
    );
  }
};

export const getJobLogs = (jobId) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get(`/api/jobs/${jobId}/logs`);
    dispatch(setJobLogs(data));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading job logs. Please try again later"
      )
    );
  }
};

export const searchJobs = (searchBy, value, dateFrom, dateTo) => async (dispatch) => {
  dispatch(setLoading());
  try {
    switch (searchBy) {
      case "serial": {
        const { data } = await axios.get(`/api/jobs/search/serial/${value}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      case "surname": {
        const { data } = await axios.get(`/api/jobs/search/surname/${value}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      case "firstName": {
        const { data } = await axios.get(`/api/jobs/search/firstName/${value}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      case "phoneNumber": {
        const { data } = await axios.get(`/api/jobs/search/phoneNumber/${value}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      case "jobNumber": {
        const { data } = await axios.get(`/api/jobs/search/jobNumber/${value}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      case "jobDate": {
        const { data } = await axios.get(`/api/jobs/search/jobDate/${dateFrom}/${dateTo}`);
        dispatch(setSearchResults(data.jobs));
        break;
      }
      default:
        break;
    }
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading job logs. Please try again later"
      )
    );
  }
};

export const getJob = (num) => async (dispatch, getState) => {
  dispatch(setLoading());
  
  try {
    //console.log({ id });
    const { data: jobData } = await axios.get(`/api/jobs/${num}`);
    
    // Check if this is a different job from what we're currently viewing
    const currentState = getState();
    const currentJobId = currentState.jobs?.job?.[0]?.JOB_ID;
    const newJobId = jobData?.[0]?.JOB_ID;
    
    // Only clear photo cache if we're switching to a different job
    if (currentJobId && newJobId && currentJobId !== newJobId) {
      dispatch(clearJobPhotosCache());
    }
    
    dispatch(setJob(jobData));
    //console.log({ jobData });

    //console.log("Fetching messages for job number:", num);
    if (jobData && jobData.length > 0 && jobData[0].JOB_NO) {
      const results1 = await axios.get(`/api/jobs/${jobData[0].JOB_NO}/smss`);
      dispatch(setMessages(results1.data.smss));
    }
    //console.log("Fetching job logs for job id:", num);
    if (jobData && jobData.length > 0 && jobData[0].JOB_ID) {
      // Load job logs WITHOUT photos first for fast initial load
      const { data: jobLogsData } = await axios.get(`/api/jobs/${jobData[0].JOB_ID}/logs?excludePhotos=true`);
      dispatch(setJobLogs(jobLogsData));
      
      // Load photos in background - fire and forget with dispatch
      // This will update the store when photos arrive
      dispatch(loadJobLogPhotos(jobData[0].JOB_ID));
    }
    //console.log({ results });
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

// export const filterBookings = (toggle) => (dispatch, getState) => {
//   dispatch(getJobs(1, toggle));
//   dispatch(setBookingsFilter(toggle));
// };

export const getTotals = (dateFrom, dateTo) => async (dispatch) => {
  dispatch(setLoading());
  //console.log("getTotal called with:", dateFrom, dateTo);
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post("/api/jobs/totals", { dateFrom, dateTo }, config);

    //const { jobs, pagination } = data;
    dispatch(setTotals(data.totals));
    //console.log({ bookingsFilter });
    //console.log({ jobs });
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred reading jobs. Please try again later"
      )
    );
  }
};

export const flagJobComplete = (id, isToggleOff = false) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const endpoint = isToggleOff ? `/api/jobs/job-complete-toggle/${id}/0` : `/api/jobs/job-complete-toggle/${id}/1`;
    await axios.get(endpoint);
    dispatch(updateJobStatus(isToggleOff ? "Not Complete" : "Completed"));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const flagJobPickedup = (id, isToggleOff = false) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const endpoint = isToggleOff ? `/api/jobs/job-pickedup-toggle/${id}/0` : `/api/jobs/job-pickedup-toggle/${id}/1`;
    await axios.get(endpoint);
    dispatch(updateJobStatus(isToggleOff ? "Not Picked Up" : "Picked Up"));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const flagJobIrreparable = (id, isToggleOff = false) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const endpoint = isToggleOff ? `/api/jobs/job-irreparable-toggle/${id}/0` : `/api/jobs/job-irreparable-toggle/${id}/1`;
    await axios.get(endpoint);
    dispatch(updateJobStatus(isToggleOff ? "Repairable" : "Not Repairable"));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const flagJobReviewRequested = (id, isToggleOff = false) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const endpoint = isToggleOff ? `/api/jobs/job-review-requested-toggle/${id}/0` : `/api/jobs/job-review-requested-toggle/${id}/1`;
    await axios.get(endpoint);
    dispatch(updateJobStatus(isToggleOff ? "Review Not Requested" : "Review Requested"));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

export const addJobLogEntry = (jobLogData) => async (dispatch) => {
  dispatch(setLoading());
  try {
    //console.log({ jobLogData });
    const config = { headers: { "Content-Type": "application/json" } };
    await axios.post(`/api/jobs/job-log-add`, jobLogData, config);
    dispatch(addToJobLogs(jobLogData));
    //dispatch(resetLoading());
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred adding job log entry. Please try again later"
      )
    );
  }
};

export const updateJobLogEntry = (id, jobLogData) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.put(`/api/jobs/job-log-update/${id}`, jobLogData, config);
    dispatch(updateJobLog(data));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred updating job log entry. Please try again later"
      )
    );
  }
};

export const deleteJobLogEntry = (id) => async (dispatch) => {
  dispatch(setLoading());
  try {
    await axios.delete(`/api/jobs/job-log-delete/${id}`);
    dispatch(removeJobLog(id));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred deleting job log entry. Please try again later"
      )
    );
  }
};

export const setProgressStatus = (id, status) => async (dispatch) => {
  dispatch(setLoading());
  try {
    //console.log({ id });
    //if (status.toUpperCase() in ["STARTED", "PAUSED", "FINISHED"]) {
    await axios.get(`/api/jobs/progress-status/${id}/${status}`);
    //}
    dispatch(updateJobProgressStatus(status));
    //dispatch(resetLoading());
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred. Please try again later"
      )
    );
  }
};

// Get next job number
export const getNextJobNumber = () => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.get("/api/jobs/next-job-number");
    return data.nextJobNo;
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred getting next job number. Please try again later"
      )
    );
    throw error;
  }
};

// Save job (create or update)
export const saveJobData = (jobData) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const { data } = await axios.post("/api/jobs/save", jobData);
    dispatch(resetLoading());
    return data;
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred saving job. Please try again later"
      )
    );
    throw error;
  }
};
export const searchJobLogs = (searchValue, page = 1, limit = 50) => async (dispatch) => {
  dispatch(setLoading());
  try {
    const config = { headers: { "Content-Type": "application/json" } };
    const { data } = await axios.post("/api/jobs/job-logs/search", { searchValue, page, limit }, config);
    dispatch(setJobLogSearchResults(data));
  } catch (error) {
    dispatch(
      setError(
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
          ? error.message
          : "An unexpected error occurred searching job logs. Please try again later"
      )
    );
  }
};

/**
 * Load photos for job logs in the background without blocking the UI
 * Fetches full job logs WITH photos and updates the store
 * Also caches the photos to preserve them across timer refreshes
 * This is called as a fire-and-forget action after initial load
 * @param {number} jobId - The job ID to fetch photos for
 */
export const loadJobLogPhotos = (jobId) => async (dispatch, getState) => {
  try {
    // Fetch full job logs WITH photos in the background
    const { data: jobLogsWithPhotos } = await axios.get(`/api/jobs/${jobId}/logs`);
    
    // Cache the photos so they persist even if the timer refreshes the job
    dispatch(cacheJobLogPhotos(jobLogsWithPhotos));
    
    // Update the store with the full job logs (including photos)
    dispatch(setJobLogs(jobLogsWithPhotos));
    console.log(`[Photos] Loaded photos for ${jobLogsWithPhotos.length} job logs`);
  } catch (error) {
    // Silent fail - if photos don't load, user still has the job logs without photos
    console.debug("Background photo loading failed (non-critical):", error.message);
  }
};